module.exports = __webpack_public_path__ + "img/1195379864.6c8daf3a.jpg";